import api from "../../api.js";

/**
 * Submit a claim for a prescription. The server routes it to whichever switching
 * house the patient's scheme uses (MediKredit, or Allegra for Bonitas), so the UI
 * doesn't need to know which one applies.
 *
 * @param {number} prescriptionid       the prescription to claim
 * @param {object} [opts]
 * @param {number} [opts.paymentid]      specific payment row (defaults to first)
 * @param {object} [opts.itemOverrides]  per-drug overrides keyed by prescriptiondrugid
 * @returns {Promise<object>} { success, approved, authNumber, totals, messages, switchHouse?, ... }
 */
export async function submitClaim(prescriptionid, opts = {}) {
  // Switch houses can take longer than the app-wide 10s default (Allegra's server
  // allows up to 90s); a client-side timeout here would hide a claim that succeeded.
  const res = await api.post("/api/claim", { prescriptionid, ...opts }, { timeout: 120000 });
  return res.data;
}

/**
 * Look up the latest accepted MediKredit claim for a prescription — used to show
 * the real switch reference (auth number) in the amend "Claim Reversal" modal.
 * @param {number} prescriptionid
 * @returns {Promise<object>} { success, found, authNumber?, transactionNumber?, submittedAt? }
 */
export async function getLatestClaim(prescriptionid) {
  const res = await api.get(`/api/claim/${prescriptionid}/latest`);
  return res.data;
}
